import { defineStore } from 'pinia'
import Axios from '@/helpers/axios'
import { MATCH_STATUSES } from '@/helpers/statuses'
import { useAuthStore } from './auth'

const STATUS_NEW = [
  MATCH_STATUSES.proposal.value,
]
const STATUS_APPROVED = [
  MATCH_STATUSES.contractSigning.value,
]
const STATUS_HIRED = [
  MATCH_STATUSES.active.value,
]
const STATUS_ARCHIVED = [
  MATCH_STATUSES.contractCompleted.value,
  MATCH_STATUSES.contractCanceled.value,
  MATCH_STATUSES.paused.value,
  MATCH_STATUSES.notHired.value,
]

export const useBusinessStore = defineStore('business', {
  persist: true,

  state: () => ({
    signupForm: {
      companyName: '',
      countryCode: null,
      phoneNr: '',
      description: '',
      headquarters: [],
      industries: [],
      employees: '',
    },
    recruiterSearch: {
      industry: [],
      languages: [],
      locations: [],
      model: [],
      roles: [],
      type: [],
      recruiter_location: 'Not important',
      results: [],
    },
    selectedMatch: null,
    selectedProject: null,
    selectedProposals: {},
  }),

  getters: {
    newProposal: (state) => {
      const business = JSON.parse(JSON.stringify(state.selectedProposals))
      if (!business.projects) {
        return {}
      }
      business.projects = business.projects.filter(project => {
        project.matches = project.matches.filter(m => STATUS_NEW.includes(m.status))
        return project.matches.length
      })
      return business
    },
    approved: (state) => {
      const business = JSON.parse(JSON.stringify(state.selectedProposals))
      if (!business.projects) {
        return {}
      }
      business.projects = business.projects.filter(project => {
        project.matches = project.matches.filter(m => STATUS_APPROVED.includes(m.status))
        return project.matches.length
      })
      return business
    },
    hired: (state) => {
      const business = JSON.parse(JSON.stringify(state.selectedProposals))
      if (!business.projects) {
        return {}
      }
      business.projects = business.projects.filter(project => {
        project.matches = project.matches.filter(m => STATUS_HIRED.includes(m.status))
        return project.matches.length
      })
      return business
    },
    archived: (state) => {
      const business = JSON.parse(JSON.stringify(state.selectedProposals))
      if (!business.projects) {
        return {}
      }
      business.projects = business.projects.filter(project => {
        project.matches = project.matches.filter(m => STATUS_ARCHIVED.includes(m.status))
        return project.matches.length
      })
      return business
    },
  },

  actions: {
    getProposals () {
      return Axios.get(`/v2/businesses/${useAuthStore().business.id}/proposals`)
        .then(({ data }) => {
          this.selectedProposals = data
          return data
        })
    },
  },
})
